import { createApiSlice } from "@common";
import { CRUD_STATUS_HISTORY } from "@routes";

const apiConfig = [
  {
    name: "getStatusHistory",
    method: "get",
    url: CRUD_STATUS_HISTORY,
    stateKey: "data",
  },
];

const customReducers = {
  initialState: {
    data: [],
  },
  reducers: {
    clearStatusHistory: (state) => {
      state.data = [];
      state.message = "";
      state.errMessage = "";
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "statusHistory",
  apiConfig,
  customReducers
);

export default slice.reducer;

export const { getStatusHistory } = thunks;

export const { clearStatusHistory } = actions;
